import React from "react"

import { useAppSelector } from "../../../../hooks"
import Header from "./Header"
import "./Header.scss"
import ItemDetailHeaderActions from "./headerActions/ItemHeaderActions"

interface OwnProps {
    itemId?: number
}
const ItemDetailHeader: React.FC<OwnProps> = ({ itemId }: OwnProps) => {
    const { item, pageHeader, isLoading } = useAppSelector(
        (state) => state.itemDetail,
    )

    return (
        <Header
            title={{
                field: { ...pageHeader.title, maxLength: 80 },
                isParentLoading: isLoading,
            }}
            actions={<ItemDetailHeaderActions />}
            breadcrumb={
                isLoading
                    ? undefined
                    : {
                          workspaceName: "",
                          workspaceUrl: "",
                          listId: item?.concept?.id,
                          listName: item?.concept?.label,
                          listUrl: "",
                          isListHidden: false,
                          name: "",
                          url: "",
                          number: item.number,
                          id: itemId ?? 0,
                      }
            }
            extraClasses="theme-item"
        />
    )
}
export default ItemDetailHeader
